import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Console } from "console";
import { StyleChoice, StyleSelection } from "../../../engine/models/models";
import { Globals } from "../../../services/globals";

@Component({
  selector: "style-selections",
  templateUrl: "style-selections.component.html",
  styleUrls: ['style-selections.component.css']
})

export class StyleSelectionsComponent implements OnInit {

  expandPopUp: boolean;
  

  constructor(
   
    @Inject(MAT_DIALOG_DATA) public displayedOption: any,
    public globals: Globals,
  ) {

  }
  ngOnInit() {
    this.displayedOption.option.styleSelections.map(q => q.isExpand = false);
    this.displayedOption.option.styleSelections[0].isExpand = true;
    this.expandPopUp = this.displayedOption.option.styleSelections.length > 1;
    

   }
  selectedStyleDescription(choices: StyleChoice[]) {
    choices = choices.sort((a: StyleChoice, b: StyleChoice) => {
      return a.displayName.localeCompare(b.displayName);
    });
    const choice = choices.filter(q => q.isSelected);
    if (!choice.length) {
      return "Selection Needed";
    }
    return choice[0].description;
  }
  panelChange(styleSelection: StyleSelection) {
    styleSelection.isExpand = true;
  }
  
}
